import TableActionButton from '@/components/Buttons/TableActionButton';
import { Delete as DeleteIcon, Share as ShareIcon } from '@mui/icons-material';
import { styled } from '@mui/material';

const ActionsCellWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-evenly',
  width: '100%',
});

interface IProps {
  onDelete: () => void;
  onShare: () => void;
}

const ActionsCell = ({ onDelete, onShare }: IProps) => (
  <ActionsCellWrapper>
    <TableActionButton variant='outlined' color='error' tooltip='Delete' onClick={onDelete}>
      <DeleteIcon />
    </TableActionButton>
    <TableActionButton variant='outlined' color='primary' tooltip='Share' onClick={onShare}>
      <ShareIcon color='primary' />
    </TableActionButton>
  </ActionsCellWrapper>
);

export default ActionsCell;
